import React from 'react';
import PropTypes from 'prop-types';
import IconHelper from '@bazooka_se/lf-icons'

export default class AccordionItem extends React.Component {
    static propTypes = {
        title: PropTypes.string,
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node,
            PropTypes.array
        ]),
        modifierClass: PropTypes.array
    }

    static defaultProps = {
        title: '',
        children: [],
        excerpt: '',
        modifierClass: []
    };

    render() {
        return (
            <li className="insurance__accordion__item insurance__accordion__item--green">
                <button className="insurance__accordion__link" data-lf-accordion>
                    <h3>{this.props.title}</h3>
                    <span dangerouslySetInnerHTML={{__html: IconHelper('chev-down').outerHTML }}></span>
                </button>
                <div className="insurance__accordion__item__content__wrapper" data-lf-accordion-body style={{maxHeight: '0px'}}>
                    <div className="insurance__accordion__item__content">
                        {this.props.children}
                    </div>
                </div>
            </li>
        );
    }
};